import React, { createContext, useContext, useState, useCallback } from "react";
import PropTypes from "prop-types";

const LoadingStateContext = createContext({ isLoading: false, isHomeScreen: false });
const LoadingActionsContext = createContext({ increment: () => { }, decrement: () => { } });

export const LoadingProvider = ({ children }) => {
  const [counts, setCounts] = useState({ total: 0, homeScreen: 0 });

  const increment = useCallback((loaderHomeScreen = false) => {
    setCounts((prev) => ({
      total: prev.total + 1,
      homeScreen: prev.homeScreen + (loaderHomeScreen ? 1 : 0),
    }));
  }, []);

  const decrement = useCallback((loaderHomeScreen = false) => {
    setCounts((prev) => ({
      total: Math.max(0, prev.total - 1),
      homeScreen: Math.max(0, prev.homeScreen - (loaderHomeScreen ? 1 : 0)),
    }));
  }, []);

  const state = { isLoading: counts.total > 0, isHomeScreen: counts.homeScreen > 0 };
  const actions = { increment, decrement };

  return (
    <LoadingActionsContext.Provider value={actions}>
      <LoadingStateContext.Provider value={state}>
        {children}
      </LoadingStateContext.Provider>
    </LoadingActionsContext.Provider>
  );
};

LoadingProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useLoadingState = () => {
  return useContext(LoadingStateContext);
};

export const useLoadingActions = () => {
  return useContext(LoadingActionsContext);
};
